import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const getEntityEmailsState = (state: RootState) => state.component.entityEmails;

export const getEmailThreadsEntity = createSelector(getEntityEmailsState, ({ entity }) => entity);

export const isEntityEmailsInitialized = createSelector(
  getEntityEmailsState,
  ({ initialized }) => initialized
);

export const getEntityEmailSync = createSelector(
  getEntityEmailsState,
  ({ entityEmailSync }) => entityEmailSync
);

export const getParentEmailThreadsFolder = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadsFolder }) => parentEmailThreadsFolder
);

export const getParentEmailThreadsSearchText = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadsSearchText }) => parentEmailThreadsSearchText
);

export const getParentEmailThreadsNeedRefresh = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadsNeedRefresh }) => parentEmailThreadsNeedRefresh
);

export const getParentEmailThreads = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreads }) => parentEmailThreads
);

export const isParentEmailThreadsLoading = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadsLoading }) => parentEmailThreadsLoading
);

export const isParentEmailThreadsSearching = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadsSearching }) => parentEmailThreadsSearching
);

export const canLoadParentEmailThreads = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreads, parentEmailThreadsTotalCount }) =>
    parentEmailThreads.length < parentEmailThreadsTotalCount
);

export const getParentEmailThread = createSelector(
  getEntityEmailsState,
  ({ parentEmailThreadId, parentEmailThreads }) =>
    parentEmailThreads.find((emailThread) => emailThread.id === parentEmailThreadId)
);

export const getChildEmails = createSelector(
  getEntityEmailsState,
  ({ childEmails }) => childEmails
);

export const isChildEmailsLoading = createSelector(
  getEntityEmailsState,
  ({ childEmailsLoading }) => childEmailsLoading
);
